import React from 'react'
import MaterialSymbol from '../material-symbol'

const Shield = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="shield" {...props} />
))

Shield.displayName = 'Shield'

export default Shield
